/*
 * � 2020 Microsoft. All rights reserved.
 */

define ('SolitaireShared/CardLogic/CardOp',['SolitaireShared/CardLogic/Supply'], function (Supply) {
    var CardOp = function (supply) {
        this.initCardOp(supply);
    };

    CardOp.Op = {
        Noop: 0,
        Move: 1,
        Undo: 2,

        Game: 9,
        Option: 10,
        Deal: 11,

        Challenge: 16,

        TotalDealsExtra: 20,
        WildCardAdd: 21,

        Begin: 29,
        End: 30,

        Error: 31
    };

    CardOp.OpTypes = [
        "Noop",
        "Move",
        "Begin",
        "End",
        "Undo",
        "Game",
        "Option",
        "Deal",
        "Challenge",
        "Error",
        "TotalDealsExtra",
        "WildCardAdd"
    ];

    CardOp.eMoveParams = { SourcePile: 1, DestPile: 2, NumCards: 3 };
    CardOp.eUndoParams = { NumMoves: 1, NumMovesUndone: 2, ScoreChange: 3 };
    CardOp.eDealParams = { DeckSeed: 1 };
    CardOp.eOptionParams = { Option: 1, Value: 2 };
    CardOp.eGameParams = { GameName: 1 };
    CardOp.eExtraDealsParams ={ DealsCount: 1 };

    CardOp.MaxParamCount = 8;

    CardOp.prototype.initCardOp = function (supply) {
        this._supply = supply;
        this.Opcode = CardOp.Op.Noop;
        this._numParams = 0;
        // Pre-parsed integer versions of all of our parameters
        this._intParams = [];

        // Any String-based parameters we might need
        this._stringParams = [];
    };

    CardOp.prototype.GetNumParams = function () {
        return this._numParams;
    };

    CardOp.prototype.GetPile = function (param) {
        if (this.Opcode != CardOp.Op.Move) return null;
        if (param == CardOp.eMoveParams.SourcePile || param == CardOp.eMoveParams.DestPile)
            return this._supply.GetPile(this._intParams[param]);
        return null;
    };

    CardOp.prototype.GetCard = function (param) {
        if (this.Opcode != CardOp.Op.Challenge) return -1;
        if (param < this._numParams && param >= 0)
        {
            return this._intParams[param+1];
        }
        return -1;
    };

    CardOp.prototype.GetNumber = function (param)
    {
        if (this.Opcode == CardOp.Op.Move) {
            if (param == CardOp.eMoveParams.NumCards) return this._intParams[param];
        }
        else if (this.Opcode == CardOp.Op.Undo) {
            if (param == CardOp.eUndoParams.NumMoves) return this._intParams[param];
            if (param == CardOp.eUndoParams.NumMovesUndone) return this._intParams[param];
            if (param == CardOp.eUndoParams.ScoreChange) return this._intParams[param];
        }
        return 0;
    };

    CardOp.prototype.GetDeck = function (param)
    {
        if (this.Opcode != CardOp.Op.Deal) return null;
        if (param == CardOp.eDealParams.DeckSeed) return this._stringParams[param];
        return null;
    };

    CardOp.prototype.GetOptionName = function (param)
    {
        if (this.Opcode != CardOp.Op.Option) return null;
        if (param == CardOp.eOptionParams.Option) return this._stringParams[param];
        return null;
    };

    CardOp.prototype.GetOptionValue = function (param)
    {
        if (this.Opcode != CardOp.Op.Option) return null;
        if (param == CardOp.eOptionParams.Value) return this._stringParams[param];
        return null;
    };

    CardOp.prototype.GetGameName = function (param)
    {
        if (this.Opcode != CardOp.Op.Game) return null;
        if (param == CardOp.eGameParams.GameName) return this._stringParams[param];
        return null;
    };

    /// <summary>
    /// Get the eOpcode entry for the given string, using Enum.TryParse (ignoring case).
    /// </summary>
    /// <param name="str">String representation of the eOpcode entry.</param>
    /// <returns>Returns an eOpcode for the string you passed in, or Noop if invalid.</returns>
    CardOp.prototype.StringToOpcode = function (str)
    {
        str = str.toLowerCase();
        if (str.length == 0) return CardOp.Op.Noop;
        for (var i = 0; i < CardOp.OpTypes.length; i++)
        {
            var name = CardOp.OpTypes[i];
            if (name.length == 0) continue;
            var nameL = name.toLowerCase();
            if (nameL[0] == str[0])
            {
                var result;
                try
                {
                    result = CardOp.Op[name];
                    if (!result)
                    {
                       return CardOp.Op.Noop;
                    }
                }
                catch (e)
                {
                    return CardOp.Op.Noop;
                }
                return result;
            }
        }
        return CardOp.Op.Noop;
    };

    /// <summary>
    /// Parse the given parameter list, and take on its values ourselves. Returns the number of parameters consumed (positive if parsing succeeded, 0 or negative if it failed).
    /// </summary>
    /// <param name="paramList">Parameter list as strings. First is op code, then 0 or more parameters.</param>
    /// <param name="startingWord"></param>
    /// <returns>Returns the number of parameters in the parameter list consumed. Negative if somehow failed to generate the operation, but still consumed parameters. 0 if a parse error occurred.</returns>
    CardOp.prototype.Parse = function (paramList, startingWord) {
        var word = startingWord;

        this.Opcode = this.StringToOpcode(paramList[word+0]);
        this.OpName = paramList[word+0];
        this._intParams = [];

        this._intParams[0] = this.Opcode;

        var paramsUsed = 0; // number of parameters used. If it ends up <=0, we had an error.
        var paramsNeeded;
        switch (this.Opcode)
        {
            case CardOp.Op.Error:
                break;
            case CardOp.Op.Noop:
                paramsNeeded = 1;
                if (paramList.length >= paramsNeeded)
                    paramsUsed = paramsNeeded;
                break;

            case CardOp.Op.Move:
                paramsNeeded = 4;
                if (paramList.length >= paramsNeeded)
                {
                    paramsUsed = paramsNeeded;

                    this._intParams[CardOp.eMoveParams.DestPile] = this.ParsePileID(paramList[word + CardOp.eMoveParams.DestPile]);
                    this._intParams[CardOp.eMoveParams.SourcePile] = this.ParsePileID(paramList[word + CardOp.eMoveParams.SourcePile]);
                    this._intParams[CardOp.eMoveParams.NumCards] = this.Parse_Count(paramList[word + CardOp.eMoveParams.NumCards]);


                    // A negative "paramsUsed" marks the operation as having a "wildcard", which means one or more params are unspecified, to be filled in later.
                    if (this._intParams[CardOp.eMoveParams.DestPile] == 0) paramsUsed = -paramsUsed;
                    else if (this._intParams[CardOp.eMoveParams.SourcePile] == 0) paramsUsed  = -paramsUsed;
                    else if (this._intParams[CardOp.eMoveParams.NumCards] == 0) paramsUsed = -paramsUsed;

                    this._numParams = 3;
                }
                break;
            case CardOp.Op.Begin:
                paramsNeeded = 1;
                if (paramList.length >= paramsNeeded)
                    paramsUsed = paramsNeeded;
                break;
            case CardOp.Op.End:
                paramsNeeded = 1;
                if (paramList.length >= paramsNeeded)
                    paramsUsed = paramsNeeded;
                break;
            case CardOp.Op.Undo:
                paramsNeeded = 2;
                if (paramList.length >= paramsNeeded)
                {
                    paramsUsed = paramsNeeded;
                    this._intParams[CardOp.eUndoParams.NumMoves] = this.Parse_Count(paramList[word + CardOp.eUndoParams.NumMoves]);
                    this._intParams[CardOp.eUndoParams.NumMovesUndone] = 0;

                    if (this._intParams[CardOp.eUndoParams.NumMoves] == 0) paramsUsed = 0; // -paramsUsed;

                    this._numParams = 1;
                }
                break;

            case CardOp.Op.Option:
                paramsNeeded = 3;
                if (paramList.length >= paramsNeeded)
                {
                    this._stringParams = [];

                    paramsUsed = paramsNeeded;

                    this._stringParams[CardOp.eOptionParams.Option] = paramList[word + CardOp.eOptionParams.Option];
                    this._stringParams[CardOp.eOptionParams.Value] = paramList[word + CardOp.eOptionParams.Value];

                    this._numParams = 2;
                }
                break;
            case CardOp.Op.Deal:
                paramsNeeded = 2;
                if (paramList.length >= paramsNeeded)
                {
                    this._stringParams = [];

                    paramsUsed = paramsNeeded;
                    this._stringParams[CardOp.eDealParams.DeckSeed] = paramList[word + CardOp.eDealParams.DeckSeed];

                    if (this._stringParams[CardOp.eDealParams.DeckSeed].length > 500)
                    {
                        paramsUsed = 0; // -paramsUsed;
                    }
                    else
                    {
                        // check to make sure it's either all digits or a valid Freecell "classic" seed
                        for (var i = 0; i < this._stringParams[CardOp.eDealParams.DeckSeed].length; i++)
                        {
                            var c = this._stringParams[CardOp.eDealParams.DeckSeed][i];
                            if (isNaN(c) && !(c == '$' && i == 0))
                            {
                                paramsUsed = 0;
                                break;
                            }
                        }
                    }   


                    this._numParams = 1;
                }
                break;
            case CardOp.Op.Game:
                paramsNeeded = 2;
                if (paramList.length >= paramsNeeded)
                {
                    this._stringParams = [];

                    paramsUsed = paramsNeeded;
                    this._stringParams[CardOp.eGameParams.GameName] = paramList[word + CardOp.eGameParams.GameName];

                    //if (!String.Equals(GetGameName(eGameParams.GameName), this._supply.GameName, StringComparison.OrdinalIgnoreCase))
                    if (!(this.GetGameName(CardOp.eGameParams.GameName).toLowerCase() == this._supply.GameName.toLowerCase()))
                    {
                        paramsUsed = -1;
                    }

                    this._numParams = 1;
                }
                break;
            case CardOp.Op.Challenge:
                paramsNeeded = 2;
                if (paramList.length >= paramsNeeded)
                {
                    paramsUsed = paramsNeeded;

                    for(var i = 0; i < paramList.length - 1; ++i)
                    {
                        this._intParams[i+1] = parseInt(paramList[word + i + 1]);
                    }

                    this._numParams = paramList.length - 1;
                }
                break;
            case CardOp.Op.TotalDealsExtra:
                paramsNeeded = 2;
                if(paramList.length >= paramsNeeded)
                {
                    paramsUsed = paramsNeeded;
                    this._intParams[1] = parseInt(paramList[word + 1]);
                    this._numParams = 1;
                }
                break;
            case CardOp.Op.WildCardAdd:
                paramsNeeded = 1;
                if (paramList.length >= paramsNeeded)
                    paramsUsed = paramsNeeded;
                break;
        }
        return paramsUsed; // unknown command!
    }


    /// <summary>
    /// Parse a pile argument string, which may specify a pile number or a name
    /// </summary>
    /// <param name="pileName"></param>
    /// <returns></returns>
    CardOp.prototype.ParsePileID = function (pileName)  // TODO: check correct
    {
        var pileNum = 0;
        var negate = false;

        if (pileName != null)
        {
            // First check if the pile name is actually an integer (and so already a pile #)
            pileNum = parseInt(pileName);
            if (!isNaN(pileNum))
            {
                // make sure it's an actual valid pile before returning this pile #
                if (this._supply.GetPile(pileNum) == null) pileNum = 0;
            }
            else {
                pileNum = 0;
            }

            if (pileNum == 0)
            {
                if (pileName[0] == "-")
                {
                    negate = true;
                    pileName = pileName.substring(1);
                }
                // try to treat PileName as a numerical pi
                pileNum = this._supply.GetPileNum(pileName);
                if (negate) pileNum = -pileNum;
                if (this._supply.GetPile(pileNum) == null) pileNum = 0;
            }
        }

        return pileNum;
    };


    /// <summary>
    /// Parse a numeric argument string
    /// </summary>
    /// <param name="param">The parameter</param>
    /// <returns>The integer, or 0</returns>
    CardOp.prototype.Parse_Count = function (param)
    {
        var output;
        if (param == null) return 0;

        output = parseInt(param);
        if (!isNaN(output))
        {
            return output;
        }
        return 0;
    };


    CardOp.prototype.ToString = function ()
    {
        var str = "";
        str += this.OpName.toUpperCase(); //(this.Opcode.toString()[0]);
        for (var i = 1; i <= this._numParams; i++)
        {
            str += " ";
            // if there is a string param, show that, otherwise show int param
            if (this._stringParams != null && this._stringParams.length >= i && this._stringParams[i] != null)
                str += (this._stringParams[i]);
            else
                str += (this._intParams[i]);
        }
        return str;
    };


    /// <summary>
    /// Run this opcode. If Supply.EnforceRules is true, will attempt to enforce the rules of the game before running, and return false if the move fails.
    /// </summary>
    /// <returns>True if the move ran, false if not.</returns>
    CardOp.prototype.Run = function () {
        switch (this.Opcode)
        {
            case CardOp.Op.Move:
                var sourcePile = this._intParams[CardOp.eMoveParams.SourcePile];
                var destPile = this._intParams[CardOp.eMoveParams.DestPile];
                var numCards = this._intParams[CardOp.eMoveParams.NumCards];

                if (sourcePile == 0 || destPile == 0 || numCards == 0) return false;

                var rev = false;
                if (numCards < 0) {
                    numCards = -numCards;
                    if(this._supply.GameName == "Spider" && this._supply.GetPile(destPile).Type == "Foundation" &&
                        this._supply.CardAnimator && !this._supply.CardAnimator.movingRunToFoundation) {
                        rev = false;
                    } else {
                        rev = true;
                    }
                }

                var cardsToMove = this._supply.GetPile(sourcePile).ForceRemoveTop(numCards);
                if (cardsToMove == null) return false;
                if (rev) cardsToMove.reverse();
                this._supply.GetPile(destPile).ForceAddTop(cardsToMove);

                if (this._supply.EnforceGameRules)
                {
                    // If we do a Move operation during the regular game, mark that we've performed at least one move. This marks the game as a "real" game.
                    this._supply.HasMovedCards = true;
                }
                break;
            case CardOp.Op.Option:
                var option = this.GetOptionName(CardOp.eOptionParams.Option);
                var value = this.GetOptionValue(CardOp.eOptionParams.Value);
                this._supply.SetOption(option, value);

                break;
            case CardOp.Op.Game:
                this._supply.Authority.Reset();

                break;
            case CardOp.Op.Deal:
                var deal = this.GetDeck(CardOp.eDealParams.DeckSeed);
                this._supply.DeckSeed = deal;
                this._supply.Authority.Deal();

                break;
            case CardOp.Op.Undo:
                // tell the action list to undo a move
                var numMovesToUndo = this._intParams[CardOp.eUndoParams.NumMoves];
                var prevScore = this._supply.Score;
                var numMovesUndone = this._supply.UndoActions(numMovesToUndo);
                this._intParams[CardOp.eUndoParams.NumMovesUndone] = numMovesUndone;
                this._intParams[CardOp.eUndoParams.ScoreChange] = this._supply.Score - prevScore;
                return numMovesUndone == numMovesToUndo;
            case CardOp.Op.TotalDealsExtra:
                var extraDealsNumber = this._intParams[CardOp.eExtraDealsParams.DealsCount];
                this._supply.Authority.AddExtraDeals(extraDealsNumber, false);
                break;
            case CardOp.Op.WildCardAdd:
                this._supply.Authority.AddWildCard(false);
                break;
        }
        return true;
    };

    /// <summary>
    /// Returns whether this opcode is undoable in general.
    /// </summary>
    /// <returns>Returns true if this opcode is undoable.</returns>
    CardOp.prototype.IsUndoable = function () {
        if (this.Opcode == CardOp.Op.Move) return true;
        return false;
    };

    /// <summary>
    /// Undo this opcode.
    /// </summary>
    /// <returns>True if the move was undone, false if not.</returns>
    CardOp.prototype.Undo = function () {
        switch (this.Opcode)
        {
            case CardOp.Op.Move:
                var sourcePile = this._intParams[CardOp.eMoveParams.SourcePile];
                var destPile = this._intParams[CardOp.eMoveParams.DestPile];
                var numCards = this._intParams[CardOp.eMoveParams.NumCards];

                if (sourcePile == 0 || destPile == 0 || numCards == 0) return false;

                var rev = false;
                if (numCards < 0)
                {
                    numCards = -numCards;
                    rev = true;
                }
                var cardsToMove = this._supply.GetPile(destPile).ForceRemoveTop(numCards);
                if (cardsToMove == null) return false;
                if (rev) cardsToMove.reverse();
                this._supply.GetPile(sourcePile).ForceAddTop(cardsToMove);

                break;
        }
        return true;
    };


    CardOp.prototype.Equals = function (op) {
        if (op == null)
            return false;

        if (this._intParams == null && op._intParams == null)
            return true;

        // return this._intParams != null && op._intParams != null && !_intParams.Where((t, i) => t != op._intParams[i]).Any();
        if (this._intParams != null && op._intParams != null && this._intParams.length == op._intParams.length) {
            for (var i = 0; i < this._intParams.length; i++) {
                if (this._intParams[i] != op._intParams[i]) {
                    return false;
                }
            }
            return true;
        }
        return false;
    };


    return CardOp;
});
